export const formatUsd = (value: number, fractionDigits = 2): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(Number.isFinite(value) ? value : 0);

/**
 * Round a USD amount to cents, half-up — the same rule as the backend
 * (``utils/money.py``, Decimal ROUND_HALF_UP). ``toFixed`` alone rounds the
 * binary float (1.005 -> "1.00") and would disagree with the server by a cent.
 */
export const roundMoney = (value: number): number => {
  if (!Number.isFinite(value)) return 0;
  const cents = Number((Math.abs(value) * 100).toPrecision(12));
  return (Math.sign(value) * Math.round(cents)) / 100;
};

export const formatNumber = (value: number, fractionDigits = 0): string =>
  new Intl.NumberFormat('uz-UZ', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(Number.isFinite(value) ? value : 0);

/** Format a number to at most 2 decimals, trimming trailing zeros (e.g. 1.50 -> "1.5", 2.00 -> "2"). */
export const formatDecimalTrim = (value: number): string =>
  value.toFixed(2).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
